<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('monte.congelation.commandes')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "CongelationCommande",
		mixins: [Navigation],
		data () {
			return {
            }
		},
        computed: {
            swiper_tabs() {
                return [{
                        id: 'demandes',
                        label: 'menu.congelation.demandes',
                        active: false,
                        href : 'CongelationCommandeDemandes',
                        icon: ['fal', 'envelope']
                    },
                    {
                        id: 'planning',
                        label: 'menu.congelation.planning',
                        active: false,
                        href : 'CongelationCommandePlanning',
                        icon: ['fal', 'clock']
                    },
                    {
                        id: 'preparation',
                        label: 'menu.congelation.preparation',
                        active: false,
                        href : 'CongelationCommandePreparation',
                        icon: ['far', 'box']
                    },
                    {
                        id: 'pret_expedier',
                        label: 'menu.congelation.pret_expedier',
                        active: false,
                        href : 'CongelationCommandePretExpedier',
                        icon: ['far', 'box-check']
                    },
                    {
                        id: 'recherche',
                        label: 'menu.congelation.recherche',
                        active: false,
                        href : 'CongelationCommandeRecherche'
                    }
                ]
            },
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
